import { http, type HttpOptions } from './httpClient'
import type {
  CommitDetail,
  CommitListResponse,
  CreateCommitRequest,
} from './types'

export const commitApi = {
  list: (projectId: number, limit?: number) =>
    http.get<CommitListResponse>(`/api/projects/${projectId}/commits/`, {
      query: limit !== undefined ? { limit } : undefined,
    }),

  get: (projectId: number, commitId: number) =>
    http.get<CommitDetail>(`/api/projects/${projectId}/commits/${commitId}/`),

  create: (projectId: number, body: CreateCommitRequest, opts?: HttpOptions) =>
    http.post<CommitDetail, CreateCommitRequest>(
      `/api/projects/${projectId}/commits/`,
      body,
      opts,
    ),

  restore: (projectId: number, commitId: number) =>
    http.post<CommitDetail>(`/api/projects/${projectId}/commits/${commitId}/restore/`),
}
